import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/api";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#072135] text-white mt-16 pb-20 lg:pb-0"
    >
      {/* Massive CTA */}
      <div className="border-b border-white/10">
        <div className="lmb-container py-16 lg:py-20 grid lg:grid-cols-3 gap-8 items-end">
          <div className="lg:col-span-2">
            <div className="text-xs font-mono-tech tracking-widest text-[#D8B86A] uppercase mb-3">
              — Demandez votre devis
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05]">
              Un projet TP ?
              <br />
              <span className="text-[#D8B86A]">Parlons-en.</span>
            </h2>
            <p className="text-white/70 mt-5 max-w-xl leading-relaxed">
              Vente de mini-pelles RIPPA neuves et d'occasion, importation de matériel
              de chantier. Notre équipe vous accompagne dans toute la France.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col gap-3">
            <Link
              to="/contact?devis=1"
              data-testid="footer-cta-devis"
              className="lmb-btn-primary justify-center"
            >
              Demander un devis
            </Link>
            <a
              href={`tel:${COMPANY.phoneTel}`}
              data-testid="footer-cta-call"
              className="lmb-btn-outline justify-center text-white border-white hover:bg-white hover:text-[#072135]"
            >
              <Phone size={16} /> Nous appeler
            </a>
          </div>
        </div>
      </div>

      {/* Columns */}
      <div className="lmb-container py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <div className="font-heading font-bold text-[#D8B86A] mb-4 text-sm uppercase tracking-widest">
            LMB Services
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            Importateur spécialisé. Vente neuf et occasion, mandat d'import de
            matériel TP partout en France.
          </p>
        </div>
        <div>
          <div className="font-heading font-bold text-[#D8B86A] mb-4 text-sm uppercase tracking-widest">
            Matériel
          </div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/mini-pelles" className="hover:text-[#D8B86A] transition-colors">Mini-pelles RIPPA</Link></li>
            <li><Link to="/mini-pelles-occasion" className="hover:text-[#D8B86A] transition-colors">Mini-pelles d'occasion</Link></li>
            <li><Link to="/mandat-import" className="hover:text-[#D8B86A] transition-colors">Mandat d'import</Link></li>
            <li><Link to="/cgv?doc=vente" className="hover:text-[#D8B86A] transition-colors">CG de vente</Link></li>
            <li><Link to="/cgv?doc=mandat-import" className="hover:text-[#D8B86A] transition-colors">CG mandat d'import</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-bold text-[#D8B86A] mb-4 text-sm uppercase tracking-widest">
            Services
          </div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/mandat-import" className="hover:text-[#D8B86A] transition-colors">Mandat d'import</Link></li>
            <li><Link to="/accessoires" className="hover:text-[#D8B86A] transition-colors">Accessoires</Link></li>
            <li><Link to="/pieces-detachees" className="hover:text-[#D8B86A] transition-colors">Pièces détachées</Link></li>
            <li><Link to="/blog" className="hover:text-[#D8B86A] transition-colors">Blog & conseils</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-bold text-[#D8B86A] mb-4 text-sm uppercase tracking-widest">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-1 text-[#D8B86A]" />
              <a href={`tel:${COMPANY.phoneTel}`} className="hover:text-[#D8B86A] transition-colors font-mono-tech">{COMPANY.phone}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 text-[#D8B86A]" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-[#D8B86A] transition-colors break-all">{COMPANY.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 text-[#D8B86A]" />
              <span className="text-white/70">{COMPANY.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="lmb-container py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {COMPANY.fullName}. Tous droits réservés.</div>
          <div className="flex flex-wrap gap-4 sm:gap-5">
            <Link to="/cgv?doc=vente" className="hover:text-[#D8B86A]">CGV</Link>
            <Link to="/cgv?doc=mandat-import" className="hover:text-[#D8B86A]">CG Mandat</Link>
            <Link to="/cgv?doc=mentions-legales" className="hover:text-[#D8B86A]">Mentions légales</Link>
            <Link to="/admin/login" className="hover:text-[#D8B86A]">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
